import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { usersQueryKeys } from '@/queries/user/user.keys';
import { MINUTE_IN_MS } from '@/constants/date.constants';

export const userQueries = {
  profile: () =>
    queryOptions({
      queryKey: usersQueryKeys.getProfile(),
      queryFn: () => api.user.getProfile(),
      retry: 0,
      enabled: () => !!localStorage.getItem('token'),
      staleTime: MINUTE_IN_MS,
    }),
  userSettings: (id?: string) =>
    queryOptions({
      queryKey: usersQueryKeys.getSettings(id),
      queryFn: () => (id ? api.user.getUserSettings(id) : null),
      enabled: !!id,
    }),
};

const useProfileQuery = () => {
  return useQuery(userQueries.profile());
};

export { useProfileQuery };
